module.exports = __webpack_public_path__ + "img/complete.f8352a5f.svg";